module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_DelphineGieux_Still.649261d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_DelphineGieux_Still.jpg
// module id = i1QF
// module chunks = 0